import { parseCoordinateInput } from "@ckgo2/shared";
import i18n from "@/i18n";

/**
 * Pole „Souřadnice hotelu" v editoru zájezdu — admin strana sdíleného `parseCoordinateInput`.
 *
 * Tři místa čtou tentýž text: `validate` pole v záložce Hotel (okamžitá odezva), obal odeslání
 * v `TripEditPage` (pole na jiné záložce je odpojené a RHF ho nevaliduje) a `transformOnSave`.
 * Hláška i převod jsou proto tady jednou.
 */

/** Lokalizovaná hláška pro neplatný vstup, `null` pro platný (i prázdný = vymazání). */
export function coordinateInputError(text: string | null | undefined): string | null {
  const result = parseCoordinateInput(text);
  if (result.ok) return null;
  return result.reason === "range"
    ? i18n.t("validation.coordinatesRange")
    : i18n.t("validation.coordinatesFormat");
}

/**
 * Převod UŽ OVĚŘENÉHO textu na sloupce API. Neplatný text sem nesmí dojít (odeslání ho zastaví
 * dřív); kdyby přesto došel, výjimka zabrání tichému přepsání souřadnic na `null`.
 */
export function coordinatesForSave(text: string | null | undefined): {
  hotelLatitude: number | null;
  hotelLongitude: number | null;
} {
  const result = parseCoordinateInput(text);
  if (!result.ok) throw new Error(`Invalid hotel coordinates reached save: ${result.reason}`);
  return {
    hotelLatitude: result.value?.lat ?? null,
    hotelLongitude: result.value?.lng ?? null,
  };
}
